import { useState, useEffect, useMemo } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
export function useChartData(parentCategory, site_id, type, span, load, extension = false) {
    const category = extension ? "chart.extensions" : parentCategory;
    const client = useQueryClient();
    const [range, setRange] = useState(span);
    const meta = useMemo(() => ({
        charts: true,
        category: parentCategory,
        site: site_id,
        type,
        start: range[0],
        end: range[1],
    }), [parentCategory, site_id, type, range]);
    const retrieve = (dataRange) => {
        const [ds, de] = dataRange;
        const [existing] = client.getQueriesData({
            predicate({ state, meta = {} }) {
                return (!state.isInvalidated &&
                    state.status === "success" &&
                    !!meta.charts &&
                    meta.category === category &&
                    meta.site === site_id &&
                    meta.type === type &&
                    meta.start <= ds &&
                    meta.end >= de);
            },
        });
        if (existing) {
            const [, value] = existing;
            return Promise.resolve(value);
        }
        return load(site_id, dataRange);
    };
    const { isLoading, isError, data, error } = useQuery({
        queryKey: [category, { site_id }, type, range],
        queryFn: () => retrieve(range),
        meta,
    });
    useEffect(() => {
        const [currentStart, currentEnd] = span;
        const [previousStart, previousEnd] = range;
        if (currentStart < previousStart || currentEnd > previousEnd) {
            let active = true;
            client
                .fetchQuery({
                queryKey: [category, { site_id }, type, span],
                queryFn: () => retrieve(span),
                meta,
            })
                .then(() => active && setRange(span));
            return () => {
                active = false;
            };
        }
    }, span);
    return { isLoading, isError, data, error };
}
//# sourceMappingURL=useChartData.js.map